import { useEffect, useCallback } from 'react';

import logBrazeEvent, { Params } from '../logBrazeEvent';

/**
 * 상품상세 페이지에서 구매 흐름상 필요한 hook들을 모아 놓은 hook
 * 상품 하나에만 의존하는 hook이라 useBrazeByProduct 명명
 */
const useBrazeByProduct = (params: Params) => {
  const brazeClickReservation = useCallback(() => {
    logBrazeEvent('click_reservation', params);
  }, [params]);

  const brazeAddWishlist = useCallback(() => {
    logBrazeEvent('add_wishlist', params);
  }, [params]);

  useEffect(() => {
    if (params.offerId) {
      logBrazeEvent('enter_offer_detail', params);
    }
  }, [params]);

  return { brazeClickReservation, brazeAddWishlist };
};

export default useBrazeByProduct;
